import { computed, ref } from 'vue'
import { updateSentryContext } from '@/utils/sentry'
import { isFgaOrganizationUser, isLegacyOrganizationUser, type User } from '../model'

const user = ref<User | null>(null)

const setUser = (newUser: User) => {
    updateSentryContext(newUser)
    user.value = newUser
}

export default function useUser() {
    return {
        user: computed(() => user.value),
        legacyOrganizationUser: computed(() => isLegacyOrganizationUser(user.value) ? user.value : undefined),
        fgaOrganizationUser: computed(() => isFgaOrganizationUser(user.value) ? user.value : undefined),
        organization: computed(() => isFgaOrganizationUser(user.value) ? user.value.organization : undefined),
        isSignedIn: computed(() => !!user.value),
        setUser,
    }
}
